import inviteByLicense from "@api/operations/invite-by-license";
import remindByLicense from "@api/operations/remind-by-license";
import { License } from "@api/types/licenses";
import React, { FC, Fragment, useEffect, useState } from "react";

import FaIcon from "@components/FaIcon";
import { IconColor, IconType } from "@components/FaIcon/FaIcon";

import EditableField from "../EditableField";

const GiftItem: FC<{ license: License }> = ({ license }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [active, setActive] = useState(false);
  const [titles, setTitles] = useState<string[]>([]);

  useEffect(() => {
    const value = license.attributes.find((a) => a.code === "assignee")?.value;

    if (value) {
      setEmail(value);
    }

    const courses = license.attributes.find((a) => a.code === "courses")?.value;

    if (courses) {
      setTitles(JSON.parse(courses));
    }
  }, [license]);

  const onClick = (code) => {
    if (!email) {
      return;
    }

    inviteByLicense({ code, email }).then((result) => {
      setMessage("success");
    });
  };

  const onRemind = (code) => {
    remindByLicense({ code }).then(() => setMessage("success"));
  };

  const activeToggle = () => {
    setActive(!active);
  };

  const findStatus = () => {
    if (license.completionStatus !== null) {
      return license.completionStatus;
    }

    return license.customerId ? "Assigned" : "Unassigned";
  };

  return (
    <React.Fragment>
      <li className="gifts-results-li">
        <div className={active ? "primary-info active" : "primary-info"}>
          <div>
            <span className="info-span" onClick={() => activeToggle()}>
              {license.id}{" "}
              <span
                onClick={async () => {
                  await navigator.clipboard.writeText(license.id);
                }}>
                <FaIcon type={IconType.Copy} color={IconColor.Secondary} />
              </span>
            </span>
            <div className="titles">
              {titles.map((title) => {
                return (
                  <div className="title" key={title}>
                    {title}
                  </div>
                );
              })}
            </div>
          </div>

          <span className="info-span">
            {license.customerId ? (
              license.customerEmail
            ) : (
              <EditableField
                type="email"
                field="email"
                value={email}
                placeholder="name@example.org"
                onFieldChange={(field, value) => {
                  setEmail(value);
                }}
              />
            )}
          </span>
          <span className="info-span">{findStatus()}</span>
          <span className="info-span">{new Date(Date.parse(license.expiration)).toLocaleDateString()}</span>
          <span className="info-span">
            {message ? (
              message
            ) : (
              <React.Fragment>
                {license.customerId ? (
                  <React.Fragment>
                    {findStatus() === "Assigned" ? (
                      <button className="button" onClick={() => onRemind(license.id)}>
                        Remind
                      </button>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ) : (
                  <button className="button" onClick={() => onClick(license.id)}>
                    Assign
                  </button>
                )}
              </React.Fragment>
            )}
          </span>
        </div>
      </li>
      {/* language=CSS */}
      <style jsx>{`
        .primary-info {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
        }

        .titles {
          text-align: left;
          font-size: 10px;
          padding: 8px;
        }

        .title {
          margin: 0 0 6px 0;
        }

        .gifts-results-li {
          z-index: 1000;
          height: 100%;
          background-color: rgb(255, 255, 255);
          border-bottom: 1px solid rgb(194, 194, 194);
          list-style: none;
          text-align: center;
        }
        .primary-info {
          cursor: pointer;
        }
        .primary-info:hover {
          background-color: rgb(239, 240, 240);
        }
        .info-span {
          vertical-align: top;
          box-sizing: border-box;
          display: inline-block;
          height: 46px;
          line-height: 46px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
        }
        .button {
          color: #fff;
          font-size: 14px;
          font-family: sans-serif;
          font-weight: bold;
          padding: 7px 10px;
          background-color: #ff3600;
        }
        @media screen and (max-width: 575px) {
          .info-span {
            width: 100%;
          }
          .info-span:not(:first-child) {
            display: ${active ? "block" : "none"};
          }
        }

        @media screen and (min-width: 768px) {
          .primary-info {
            grid-template-columns: repeat(5, 1fr);
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default GiftItem;
